module.exports = __webpack_public_path__ + "static/media/1POLICY22.24f04115.jpg";